export const toDateRangeObjects = (dateRangeStrings) => {
  return dateRangeStrings.map((dateRange) => {
    const split = dateRange.split('|');
    return {
      min: split[0],
      max: split[1],
    };
  });
};

export const toDateRangeStrings = (dateRangeObjects) => {
  return dateRangeObjects.map(
    (dateRange) =>
      `${dateRange.min || dateRange.minDate}|${dateRange.max ||
        dateRange.maxDate}`,
  );
};
